<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            لیست بار های حمل شده
          </v-card-title>
          <v-card-text>
            <div class="container">
              <v-row>
                <v-col cols="4">
                  <v-row form class="form-group">
                    <label class="col-form-label">
                      از تاریخ
                    </label>
                    <div>
                      <ThreeDatePicker
                              @last_focus="another_focus_select('end_date_id_date_day')"
                              first_id="start_date_id_"
                              v-model="start_date" />
                    </div>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row form class="form-group">
                    <label class="col-form-label">
                      تا تاریخ
                    </label>
                    <div>
                      <ThreeDatePicker
                              first_id="end_date_id_"
                              @last_focus="another_focus('barname_report_delivery')"


                              v-model="end_date" />
                    </div>
                  </v-row>
                </v-col>
                <v-col cols="3">
                  <v-row form class="form-group">
                    <div dir="rtl">
                      <treeselect
                              :matchKeys="['code']"
                              v-model="selected_discharge_place"
                          :cacheOptions="false"
                          id="discharge_place"
                          :options="discharge_places"
                          placeholder="جستجو محل تخلیه"
                          :normalizer="normalizer_discharge_place"
                      />
                    </div>
                  </v-row>
                </v-col>
              </v-row>

<br>
              <v-data-table
                  dense
                  hide-default-footer
                  height="400"
                  fixed-header
                  disable-pagination
                  multi-sort
                  class="margin-auto  table-bordered"
                  :headers="headers_deliver"
                  :items-per-page="1000"
                  :items="items_delivery"
              >
                <template v-slot:item.row_id="{ item }">
                  {{ item.row_id + 1 }}
                </template>


                <template v-slot:item.driver_price="{ item }">
                  {{ get_currency(item.driver_price) }}
                </template>
                <template v-slot:item.limited_tonaje="{ item }">
                  {{ (limited_tonaje(item)) }}
                </template>
                <template v-slot:item.calculated_driver_price="{ item }">
                  {{ get_currency(item.calculated_driver_price) }}
                </template>
                <template v-slot:item.calculated_employer_price="{ item }">
                  {{ get_currency(item.calculated_employer_price) }}
                </template>
              </v-data-table>
<v-row>
  <v-col>جمع کل تناژ {{calculate_items(items_delivery,'real_tonaje')}}</v-col>
</v-row>

            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Vue from 'vue'
import { bus } from '../../main'
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import ThreeDatePicker from "../includes/ThreeDatePicker";
export default {
  name: 'OriginDownload',
  components: {
    Treeselect,
    ThreeDatePicker
  },
  data () {
    return {
      tab: null,
      confirm_delete_name: 'confirm_delete' + new Date().getTime() + '_' + this.$vnode.tag,
      items_delivery: [],

      status_form: 0,
      discharge_places: [],

      selected_discharge_place: null,
      start_date: null,
      end_date: null,
      headers_deliver: [
        {
          text: 'ردیف',
          value: 'row_id'
        },
        {
          text: 'تاریخ',
          value: 'doc_date_persian'
        },
        {
          text: 'شماره بارنامه',
          value: 'barname'
        },
        {
          text: 'شماره پلاک',
          value: 'truck_plate'
        },
        {
          text: 'نام کامیون',
          value: 'truck_name'
        },
        {
          text: 'نام کامیوندار',
          value: 'truck_driver'
        },
        {
          text: 'تناژ',
          value: 'real_tonaje'
        },

      ],

      normalizer_origin (node) {
        return {
          id: node.id,
          label: node.code + ' - ' + node.name,
          code:node.code,

        }
      },
      normalizer_load_type (node) {
        return {
          id: node.id,
          label: node.code + ' - ' + node.name,
          code:node.code,

        }
      },
      normalizer_discharge_place (node) {
        return {
          id: node.id,
          label: node.code + ' - ' + node.name,
          code:node.code,

        }
      },
    }
  },
  mounted () {
    // this.get_data()

    this.get_discharge_places()
    this.start_date = this.miladi_to_jalali(this.get_today())
    this.end_date = this.miladi_to_jalali(this.get_today())

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == 'true') {
        this.delete_item()

      } else {
        this.status_form = 0
      }
    })
  },
  watch: {
    start_date: function () {
      this.get_data()
    },
    end_date: function () {
      this.get_data()
    },

    selected_discharge_place: function () {
      this.get_data()
    },

  },
  methods: {

    limited_tonaje (item) {

      var price = item.driver_price
      var tonaje = parseFloat(item.tonaje)
      if (item.tonaje_limit == 1) {
        if (item.truck_type == 1 && tonaje > item.tak_limit_tonaje) {
          tonaje = item.tak_limit_tonaje
        }
        if (item.truck_type == 2 && tonaje > item.joft_limit_tonaje) {
          tonaje = item.joft_limit_tonaje
        }
      }
return tonaje;
    },
    real_paying_driver (item) {

      var price = item.driver_price
      var tonaje = parseFloat(item.tonaje)
      if (item.tonaje_limit == 1) {
        if (item.truck_type == 1 && tonaje > item.tak_limit_tonaje) {
          tonaje = item.tak_limit_tonaje
        }
        if (item.truck_type == 2 && tonaje > item.joft_limit_tonaje) {
          tonaje = item.joft_limit_tonaje
        }
      }
      return (parseFloat(price) * tonaje)
    },
    deliver_employer (item) {

      var price = item.employer_price
      var tonaje = parseFloat(item.tonaje)
      if (item.tonaje_limit == 1) {
        if (item.truck_type == 1 && tonaje > item.tak_limit_tonaje) {
          tonaje = item.tak_limit_tonaje
        }
        if (item.truck_type == 2 && tonaje > item.joft_limit_tonaje) {
          tonaje = item.joft_limit_tonaje
        }
      }
      return (parseFloat(price) * tonaje)

    },

    get_data () {
      if (this.selected_discharge_place == null) {
        return
      }
      this.get_delivery()

    },
    get_delivery () {
      var self = this
      const formData = new FormData()
      formData.append('start_date', this.jalali_to_miladi(this.start_date))
      formData.append('end_date', this.jalali_to_miladi(this.end_date))

      formData.append('discharge_id', this.selected_discharge_place)
      this.axios.post('/api/delivery_document/select_by_discharge', formData, {}).then(function (response) {

        // items = content_cats.orders;
        if (response.data.error == 0) {

          self.items_delivery =  response.data.data.map((item, row_id) => { return {...item, row_id}})

          self.items_delivery.forEach(function (val) {
            val.calculated_driver_price = self.real_paying_driver(val)
            val.calculated_employer_price = self.deliver_employer(val)
            val.tonaje = parseFloat(val.tonaje).toFixed(3)
          })
        } else {
          self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

        }

      }).catch(function (error) {
        self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

        console.log(error)
      })

    },

    get_discharge_places () {
      var self = this
      const formData = new FormData()
      // formData.append('id', this.selected_province);
      this.axios.post('/api/discharge_places/select', formData, {}).then(function (response) {

        // items = content_cats.orders;
        if (response.data.error == 0) {

          self.discharge_places = response.data.data

        } else {
          self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

        }
        if (self.$route.params.doc_id != null) {
          self.status_form = self.$route.params.doc_id
          self.get_data()
        }
      }).catch(function (error) {
        self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

        console.log(error)
      })

    },
    edit_item (item) {
      this.$router.push({ path: '/edit-delivery-document/' + item.id })
    },
    delete_item_dialog (item) {
      this.$root.modal_component.show_confirm_modal('هشدار', 'آیا مایل به حذف این ردیف هستید؟', ['تایید'], this.confirm_delete_name)
      this.status_form = item.id
    },
    delete_item () {
      const self = this
      const formData = new FormData()
      const url = '/api/delivery_document/delete'
      formData.append('id', this.status_form)

      this.axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res)
        self.status_form = 0

        self.get_data()

      })
          .catch(function (error) {
            console.log(error)
          })
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },

  }
}
</script>
